import { useState, useEffect } from "react";
import { Modal, Button, Form, Alert } from "react-bootstrap";
import { toast } from "react-toastify";
import { createStage, updateStage } from "../Api/StageMaster";

const StageModal = ({ show, onHide, stage, projectId, onStageSaved }) => {
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;
  const orgId = userDetails?.organisationId;

  const [formData, setFormData] = useState({
    stageName: "",
    stageDescription: "",
    stageProjectBelong: projectId || "",
    orgId: String(orgId) || "",
    createdBy: String(userId) || "",
  });

  console.log(formData);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (stage) {
      // Edit mode
      setFormData({
        stageName: stage.stageName || "",
        stageDescription: stage.stageDescription || "",
        stageProjectBelong: stage.stageProjectBelong || projectId || "",
        orgId: stage.orgId || "",
        createdBy: stage.createdBy || userId?.toString() || "",
      });
    } else {
      // Create mode
      setFormData({
        stageName: "",
        stageDescription: "",
        stageProjectBelong: projectId || "",
        orgId: String(orgId) || "",
        createdBy: userId?.toString() || "",
      });
      console.log(formData);
    }
    setErrors({});
  }, [stage, show, projectId, userId]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.stageName.trim()) {
      newErrors.stageName = "Stage name is required";
    }

    if (!formData.stageProjectBelong) {
      newErrors.stageProjectBelong = "Project ID is required";
    }

    if (!formData.orgId) {
      newErrors.orgId = "Organization ID is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      if (stage) {
        // Update existing stage
        await updateStage(stage.stageId, formData);
        toast.success("Stage updated successfully");
      } else {
        // Create new stage
        await createStage(formData);
        toast.success("Stage created successfully");
      }

      onStageSaved();
      onHide();
    } catch (error) {
      console.error("Error saving stage:", error);
      toast.error(error.message || "Failed to save stage");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // Clear error when user starts typing
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{stage ? "Edit Stage" : "Add New Stage"}</Modal.Title>
      </Modal.Header>

      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {errors.general && <Alert variant="danger">{errors.general}</Alert>}

          <Form.Group className="mb-3">
            <Form.Label>Stage Name *</Form.Label>
            <Form.Control
              type="text"
              value={formData.stageName}
              onChange={(e) => handleChange("stageName", e.target.value)}
              isInvalid={!!errors.stageName}
              placeholder="Enter stage name"
            />
            <Form.Control.Feedback type="invalid">
              {errors.stageName}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Stage Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={formData.stageDescription}
              onChange={(e) => handleChange("stageDescription", e.target.value)}
              placeholder="Enter stage description"
            />
          </Form.Group>

          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Project ID *</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.stageProjectBelong}
                  onChange={(e) =>
                    handleChange("stageProjectBelong", e.target.value)
                  }
                  isInvalid={!!errors.stageProjectBelong}
                  disabled={!!projectId} // Disable if projectId is provided
                />
                <Form.Control.Feedback type="invalid">
                  {errors.stageProjectBelong}
                </Form.Control.Feedback>
              </Form.Group>
            </div>

            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label>Organization ID *</Form.Label>
                <Form.Control
                  type="text"
                  value={formData.orgId}
                  onChange={(e) => handleChange("orgId", e.target.value)}
                  isInvalid={!!errors.orgId}
                  disabled={!!orgId} // Disable if orgId is provided
                />
                <Form.Control.Feedback type="invalid">
                  {errors.orgId}
                </Form.Control.Feedback>
              </Form.Group>
            </div>
          </div>

          <Form.Group className="mb-3">
            <Form.Label>Created By</Form.Label>
            <Form.Control
              type="text"
              value={formData.createdBy}
              onChange={(e) => handleChange("createdBy", e.target.value)}
              disabled
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide} disabled={loading}>
            Cancel
          </Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? "Saving..." : stage ? "Update Stage" : "Create Stage"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default StageModal;
